module.exports = __webpack_public_path__ + "img/co-branding-world-JET-3.cbff2864.gif";